import { connect } from 'react-redux'
import AppNotFoundView from '../components/AppNotFoundView'
import {changeStep} from "../../../../layouts/Content/modules/step";

const mapDispatchToProps = {
  changeStep: changeStep
};

const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(AppNotFoundView)


// WEBPACK FOOTER //
// ./src/components/Applications/AppNotFound/containers/AppNotFoundContainer.js